export default {
  name: 'oz-accordion-amenities',

  props: {
    title: { type: String, required: true },
    items: { type: Array, required: true },
    amenities: { type: Array, default: () => [] },
  },

  data () {
    return {
      values: [],
    }
  },

  watch: {
    amenities () {
      this.selectValue()
    },
  },

  created () {
    this.selectValue()
  },

  computed: {
    categoryTitle () {
      const count = this.items.filter((i) => !!this.amenities.includes(i.id)).map((a) => a && a.id)

      return `${this.title} ${count.length ? `(${count.length})` : ''}`
    },
  },

  methods: {
    selectValue () {
      this.values = this.amenities
    },

    onChange () {
      this.$emit('filters:update', { amenities: this.values })
    },
  },
}
